import { Box, Button } from "@mui/material";
import type { FC, ReactNode } from "react";
import { useState } from "react";
import { EmptyPlaceholderText } from "../inlineForm/EmptyPlaceholderText";

type AddDialogTriggerProps = {
  renderDialog: (props: { onClose: () => void }) => ReactNode;
  isMultistepFormVersion?: boolean;
  isReadOnly?: boolean;
  isEmpty?: boolean;
} & ({ children?: ReactNode } | { renderTrigger: (props: { onClick: () => void }) => ReactNode });

export const AddDialogTrigger: FC<AddDialogTriggerProps> = ({
  renderDialog,
  isMultistepFormVersion,
  isReadOnly,
  isEmpty,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isAddButtonOnly = "children" in props;
  const hideAddButton = isAddButtonOnly && !isEmpty && isReadOnly;
  if (hideAddButton) return null;

  const showEmptyState = !isMultistepFormVersion && isEmpty;
  const disabled = isMultistepFormVersion && isReadOnly && isEmpty;
  return (
    <>
      {isOpen && renderDialog({ onClose: () => setIsOpen(false) })}
      <Box>
        {"renderTrigger" in props && !showEmptyState ? (
          props.renderTrigger({ onClick: () => setIsOpen(true) })
        ) : (
          <Button
            sx={{
              "py": 1.5,
              "px": 2,
              "fontWeight": 600,
              "fontSize": theme => theme.typography.pxToRem(12),
              ":hover": { backgroundColor: theme => theme.palette.action.hover },
              ":focus-visible": { outline: "2px solid", outlineColor: theme => theme.palette.primary["500"] },
              ...(showEmptyState && {
                "width": "100%",
                "justifyContent": "flex-start",
                "py": "7.5px",
                ":hover": { backgroundColor: theme => theme.palette.action.hover },
              }),
            }}
            variant="text"
            onClick={() => setIsOpen(true)}
            disabled={disabled || isReadOnly}
          >
            {showEmptyState ? <EmptyPlaceholderText /> : "children" in props ? props.children : null}
          </Button>
        )}
      </Box>
    </>
  );
};
